import { applyFilters, doRequest } from "./helpers";

export default class SwoogoService {
  static async listEvents(filters = null) {
    return doRequest("GET", applyFilters(filters, "/swoogo/events"));
  }

  static async listEventStatuses() {
    return doRequest("GET", "/swoogo/events/statuses");
  }

  static async getEvent(eventId) {
    return doRequest("GET", `/swoogo/events/${eventId}`);
  }

  static async listEventFolders(filters = null) {
    return doRequest("GET", applyFilters(filters, "/swoogo/event-folders"));
  }

  static async listRegistrants(filters = null) {
    return doRequest("GET", applyFilters(filters, "/swoogo/registrants"));
  }

  static async getRegistrant(registrantId) {
    return doRequest("GET", `/swoogo/registrants/${registrantId}`);
  }

  static async linkRegistrantContact(registrantId, contactId) {
    return doRequest("PUT", `/swoogo/registrants/${registrantId}/contact`, {
      data: { contact_id: contactId },
    });
  }

  static async updateRegistrant(registrantId, data) {
    return doRequest("PUT", `/swoogo/registrants/${registrantId}`, { data });
  }

  static async unlinkRegistrantContact(registrantId) {
    return doRequest("DELETE", `/swoogo/registrants/${registrantId}/contact`);
  }

  static async removeSessionRegistrants(sessionIds, registrantIds) {
    return doRequest("POST", "/swoogo/remove-session-registrants", {
      data: { session_ids: sessionIds, registrant_ids: registrantIds },
    });
  }

  static async listSessions(filters = null) {
    return doRequest("GET", applyFilters(filters, "/swoogo/sessions"));
  }

  static async getSession(sessionId) {
    return doRequest("GET", `/swoogo/sessions/${sessionId}`);
  }

  static async listAttendances(filters = null) {
    return doRequest("GET", applyFilters(filters, "/swoogo/attendances"));
  }

  static async getStatus({ suppressForbiddenModal } = {}) {
    return doRequest("GET", "/swoogo/status", { suppressForbiddenModal });
  }

  static async getConnection() {
    return doRequest("GET", "/swoogo/connection");
  }

  static async updateConnection(data) {
    return doRequest("PUT", "/swoogo/connection", { data });
  }

  static async testConnection(data) {
    return doRequest("POST", "/swoogo/connection/test", { data });
  }

  static async getFolders() {
    return doRequest("GET", "/swoogo/connection/folders");
  }

  static async syncFolders() {
    return doRequest("POST", "/swoogo/connection/folders/sync");
  }

  static async syncData(scope) {
    return doRequest("POST", "/swoogo/connection/sync", { data: { scope } });
  }
}
